export enum EnvName {
    TESTING = 'staging',
    DEV = 'test',
    PROD = 'prod',
}
